import AltairPlot from "../../../../src/blog/altairPlot/AltairPlot.js";
import data1 from "../../../../src/blog/2018-05-31-inei-crime-data/data1.js";
import data2 from "../../../../src/blog/2018-05-31-inei-crime-data/data2.js";
import * as React from 'react';
export default {
  AltairPlot,
  data1,
  data2,
  React
};